// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.single-ticket{
    display:flex;
    flex-direction:column;
    width:100%;
    border:2px solid rgb(237, 238, 240);
    border-radius: 0.5rem;
    padding:1.25rem;
    justify-content: flex-start; 
    height: max-content;  
}
.ticket-status-container{
    display: flex;
    align-items: center;
    font-size:1.125rem;
    margin-bottom:0.7rem;
    gap: 0.75rem;
    font-weight: 500;
}
.status{
    border-radius:0.25rem;
    font-size: 14px;
    font-weight: 600;
    padding:0.5rem;
    padding-top:0.25rem;
    padding-bottom:0.25rem;
}
.support-ticket-open{
    color:rgb(105, 65, 0);
    background-color: rgb(255, 243, 214);
}
.support-ticket-resolved{
    color:rgb(15, 107, 15);
    background-color: rgb(243, 255, 246);
}
.support-ticket-progress{
    color:rgb(0, 82, 120);
    background-color: rgb(224, 241, 245);
}
.time-container{
    margin-bottom:1.25rem;
}
.file-type-container{
    display: flex;
    gap:5rem;
    align-items: center;
    font-size:1rem;
    margin-bottom:1.25rem;
    /* justify-content: space-between; */
}
.file-container,.file-length-container{
    display: flex;
    align-items: center;
    justify-content: center;
}
.time-container,.file-type-container,.comments-container{
    color:rgb(115, 123, 132);
}
.file-length-container > span{
    color:rgb(115, 123, 132);
}
.file-length-container:hover{
    cursor: not-allowed;
}
/* .comments-container:hover,.file-length-container:hover{
    cursor: pointer;
} */
.comments-container:hover,.file-length-container:hover{
    cursor: not-allowed;
}
.chip,.folder,.comments{
   margin-right:0.5rem;
   height:1.25rem;
   width:1.25rem;
}
.comments-container{
    display: flex;
    align-items: center;
}
.greater-than-container{
    margin-left:0.25rem;
    color:rgb(64, 64, 242);
}
`, "",{"version":3,"sources":["webpack://./src/pages/support/Ticket/Ticket.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,qBAAqB;IACrB,UAAU;IACV,mCAAmC;IACnC,qBAAqB;IACrB,eAAe;IACf,2BAA2B;IAC3B,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,qBAAqB;IACrB,oCAAoC;AACxC;AACA;IACI,sBAAsB;IACtB,oCAAoC;AACxC;AACA;IACI,qBAAqB;IACrB,oCAAoC;AACxC;AACA;IACI,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,cAAc;IACd,qBAAqB;IACrB,oCAAoC;AACxC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,mBAAmB;AACvB;AACA;;GAEG;AACH;IACI,mBAAmB;AACvB;AACA;GACG,mBAAmB;GACnB,cAAc;GACd,aAAa;AAChB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,sBAAsB;AAC1B","sourcesContent":[".single-ticket{\r\n    display:flex;\r\n    flex-direction:column;\r\n    width:100%;\r\n    border:2px solid rgb(237, 238, 240);\r\n    border-radius: 0.5rem;\r\n    padding:1.25rem;\r\n    justify-content: flex-start; \r\n    height: max-content;  \r\n}\r\n.ticket-status-container{\r\n    display: flex;\r\n    align-items: center;\r\n    font-size:1.125rem;\r\n    margin-bottom:0.7rem;\r\n    gap: 0.75rem;\r\n    font-weight: 500;\r\n}\r\n.status{\r\n    border-radius:0.25rem;\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n    padding:0.5rem;\r\n    padding-top:0.25rem;\r\n    padding-bottom:0.25rem;\r\n}\r\n.support-ticket-open{\r\n    color:rgb(105, 65, 0);\r\n    background-color: rgb(255, 243, 214);\r\n}\r\n.support-ticket-resolved{\r\n    color:rgb(15, 107, 15);\r\n    background-color: rgb(243, 255, 246);\r\n}\r\n.support-ticket-progress{\r\n    color:rgb(0, 82, 120);\r\n    background-color: rgb(224, 241, 245);\r\n}\r\n.time-container{\r\n    margin-bottom:1.25rem;\r\n}\r\n.file-type-container{\r\n    display: flex;\r\n    gap:5rem;\r\n    align-items: center;\r\n    font-size:1rem;\r\n    margin-bottom:1.25rem;\r\n    /* justify-content: space-between; */\r\n}\r\n.file-container,.file-length-container{\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n.time-container,.file-type-container,.comments-container{\r\n    color:rgb(115, 123, 132);\r\n}\r\n.file-length-container > span{\r\n    color:rgb(115, 123, 132);\r\n}\r\n.file-length-container:hover{\r\n    cursor: not-allowed;\r\n}\r\n/* .comments-container:hover,.file-length-container:hover{\r\n    cursor: pointer;\r\n} */\r\n.comments-container:hover,.file-length-container:hover{\r\n    cursor: not-allowed;\r\n}\r\n.chip,.folder,.comments{\r\n   margin-right:0.5rem;\r\n   height:1.25rem;\r\n   width:1.25rem;\r\n}\r\n.comments-container{\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n.greater-than-container{\r\n    margin-left:0.25rem;\r\n    color:rgb(64, 64, 242);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
